import styled from 'styled-components'

import { helpers } from 'styles'

export const Suffix = styled.div`
	position: absolute;
	top: 9.5px;
	right: 8px;
	font-size: ${helpers.font.size.base};
	font-weight: 500;
	z-index: 2;
`
